import { BannerCTA } from 'app/components/BannerCTA'
import { GallerySlider } from 'app/components/GallerySlider'
import { Hero } from 'app/components/Hero'
import { Info } from 'app/components/Info'
import { Intro } from 'app/components/Intro'
import { SEO } from 'app/components/SEO'
import {
  Props as StructuredDataProps,
  StructuredData,
} from 'app/components/StructuredData'
import { ZigZags } from 'app/components/ZigZags'
import { Footer, Props as FooterProps } from 'app/containers/Footer'
import { Header, Props as HeaderProps } from 'app/containers/Header'
import { PageProps } from 'gatsby'
import React, { memo } from 'react'

import { Props } from './contents'

export interface PageContext {
  id: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
  footerProps?: FooterProps
  structuredDataProps?: StructuredDataProps
}

export interface Context extends PageContext {
  props: Props
}

export const Head = ({ pageContext }: PageProps<void, Context>) => {
  const context = pageContext as any

  return <SEO {...context.seoProps} />
}

export default memo(function RestaurantPageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  return (
    <>
      {context.structuredDataProps ? (
        <StructuredData
          languageCode={pageContext.languageCode}
          {...context.structuredDataProps}
        />
      ) : null}
      {context.headerProps ? (
        <Header
          languageCode={context.languageCode}
          languagePrefix={context.languagePrefix}
          pageID={context.id}
          {...context.headerProps}
        />
      ) : null}
      {context.heroProps ? (
        <Hero {...context.heroProps} languagePrefix={context.languagePrefix} />
      ) : null}
      {context.introProps ? <Intro {...context.introProps} /> : null}
      {context.zigZagsProps ? <ZigZags {...context.zigZagsProps} /> : null}
      {context.infoProps ? <Info {...context.infoProps} /> : null}
      {context.gallerySliderProps ? (
        <GallerySlider {...context.gallerySliderProps} />
      ) : null}
      {context.bannerCTAProps ? (
        <BannerCTA {...context.bannerCTAProps} />
      ) : null}
      {context.footerProps ? (
        <Footer languageCode={context.languageCode} {...context.footerProps} />
      ) : null}
    </>
  )
})
